export function calculateAge(dateOfBirth) {
  if (!dateOfBirth) return null;

  const dob = new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age -= 1;
  }

  return age;
}

/** ISO date string (YYYY-MM-DD) for someone who must be at least `minAge` years old. */
export function maxBirthDateForMinAge(minAge = 18) {
  const d = new Date();
  d.setFullYear(d.getFullYear() - minAge);
  return d.toISOString().split("T")[0];
}

/** ISO date string (YYYY-MM-DD) for maximum age cap. */
export function minBirthDateForMaxAge(maxAge = 100) {
  const d = new Date();
  d.setFullYear(d.getFullYear() - maxAge);
  return d.toISOString().split("T")[0];
}
